import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import _ from 'lodash';
import agenticSearchCn from '@/locales/agentic-search/cn.json';
import agenticSearchEn from '@/locales/agentic-search/en.json';
import agenticSearchJp from '@/locales/agentic-search/jp.json';
import agenticSearchTw from '@/locales/agentic-search/tw.json';
import coverageCn from '@/locales/coverage/cn.json';
import coverageEn from '@/locales/coverage/en.json';
import coverageJp from '@/locales/coverage/jp.json';
import coverageTw from '@/locales/coverage/tw.json';

const coverageMessages = {
    cn: coverageCn,
    en: coverageEn,
    jp: coverageJp,
    tw: coverageTw,
};

const agenticSearchMessages = {
    cn: agenticSearchCn,
    en: agenticSearchEn,
    jp: agenticSearchJp,
    tw: agenticSearchTw,
};
type AgenticSearchLocale = keyof typeof agenticSearchMessages;

function normalizeLocalLocale(locale: string): AgenticSearchLocale {
    if (locale === 'cn' || locale === 'en' || locale === 'jp' || locale === 'tw') {
        return locale;
    }
    return 'en';
}

export function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage()
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
    })
}
export const i18n = createI18nInstance()

export async function loadI18n() {
    const lang = getCurrentLanguage()
    const localLocale = normalizeLocalLocale(lang);
    let results;
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/cn.json'),
            import('CommonMessages/eureka-air/cn.json')
        ])
    }
    if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/en.json'),
            import('CommonMessages/eureka-air/en.json')
        ])
    }
    if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/jp.json'),
            import('CommonMessages/eureka-air/jp.json')
        ])
    }
    if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/tw.json'),
            import('CommonMessages/eureka-air/tw.json')
        ])
    }

    const data = results?.reduce((obj, { default: data }) => {
        return _.merge(obj, data);
    }, {});

    if (data) {
        i18n.global.mergeLocaleMessage(lang, data);
    }
    i18n.global.mergeLocaleMessage(lang, {
        agenticSearch: agenticSearchMessages[localLocale],
        coverage: coverageMessages[localLocale],
    });
    return i18n;
}
